/* Contador redondo de cabecera de tarjeta (handoff V2: --evo-badge-sq).
 * Distinto del Badge/Pill: es un disco fijo de 20px, cian sobre veladura
 * cian, sin variantes. Se usa en las cabeceras de tarjeta del dashboard y
 * de las tarjetas de Relacionados en pantallas de detalle. */

export interface CounterBadgeProps {
  count: number | string;
}

export function CounterBadge({ count }: CounterBadgeProps) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'var(--evo-badge-sq)',
        height: 'var(--evo-badge-sq)',
        padding: 0,
        fontSize: 'var(--evo-fs-caption)',
        fontWeight: 600,
        fontFamily: 'var(--evo-font)',
        lineHeight: 1,
        color: 'var(--evo-cyan)',
        background: 'var(--evo-cyan-12)',
        border: '1px solid transparent',
        borderRadius: '50%',
        boxSizing: 'border-box',
        flexShrink: 0,
      }}
    >
      {count}
    </span>
  );
}
